import { useTheme } from "../theme/styled/theme/themeContext/themeContext";
import type { ThemeName } from "../theme/styled/theme/types/themeName";

function isDarkMode(theme: ThemeName): boolean {
  return theme === "dark";
}

export function useIsDarkMode(): boolean {
  const { themeName } = useTheme();
  return isDarkMode(themeName);
}
